import React from 'react';
import { Provider } from 'react-redux';
import PropTypes from 'prop-types';
import { ReviewsContextProvider } from '../shared/context';
import { initStoreAndServices } from '../../config';
import Reviews from './Reviews';

class Index extends React.Component {
    constructor(props) {
        super(props);
        this.store = initStoreAndServices(props.initialState);
    }

    render() {
        const {
            initialState,
            userName,
            selfView,
            isBuyerProfile,
            onFilterChange,
            onLoadMoreClick,
            enableSearchFilter,
            enableReliableReviews,
            shouldAllocateForReliableReviews,
            reliableReviewsKillswitch,
            translationUrl,
            displayPurchasedGig,
        } = this.props;

        return (
            <Provider store={this.store}>
                <ReviewsContextProvider
                    initialState={initialState}
                    enableSearchFilter={enableSearchFilter}
                    enableReliableReviews={enableReliableReviews}
                    shouldAllocateForReliableReviews={shouldAllocateForReliableReviews}
                    reliableReviewsKillswitch={reliableReviewsKillswitch}
                    translationUrl={translationUrl}
                    displayPurchasedGig={displayPurchasedGig}
                >
                    <Reviews
                        isBuyerProfile={isBuyerProfile}
                        selfView={selfView}
                        userName={userName}
                        onFilterChange={onFilterChange}
                        onLoadMoreClick={onLoadMoreClick}
                    />
                </ReviewsContextProvider>
            </Provider>
        );
    }
}

Index.propTypes = {
    userName: PropTypes.string,
    selfView: PropTypes.bool,
    isBuyerProfile: PropTypes.bool,
    onFilterChange: PropTypes.func,
    onLoadMoreClick: PropTypes.func,
    enableSearchFilter: PropTypes.bool,
    enableReliableReviews: PropTypes.bool,
    translationUrl: PropTypes.string,
    displayPurchasedGig: PropTypes.bool,
};

Index.defaultProps = {
    enableSearchFilter: false,
    selfView: false,
    isBuyerProfile: false,
};

export default Index;
